export const cars = [
  {
    id: 1,
    name: 'MUSTANG CABRIOLET',
    model: 'Ford Mustang GT Convertible',
    type: 'Cabriolet Sport',
    seats: 4,
    doors: 2,
    transmission: 'Automatique',
    fuel: 'Essence',
    engine: '450 CH V8',
    pricePerDay: 290,
    image: 'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/be818d6b0f68bc9637377cb5bd859722.jpeg',
    gallery: [
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/be818d6b0f68bc9637377cb5bd859722.jpeg',
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/0c28d3aea2f160869eabbc2ea7ea9758.jpeg',
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/23e0563a96533e6222ea70c8ca4154bd.jpeg'
    ],
    description: 'Icône américaine sur la Côte d\'Azur. La Mustang GT Cabriolet blanche offre puissance et style pour des moments inoubliables cheveux au vent sur les routes de la Riviera.',
    features: [
      'Toit décapotable électrique',
      'GPS intégré',
      'Sièges cuir chauffants',
      'Système audio premium',
      'Bluetooth',
      'Caméra de recul'
    ]
  },
  {
    id: 2,
    name: 'MUSTANG CABRIOLET',
    model: 'Ford Mustang GT Convertible',
    type: 'Cabriolet Sport',
    seats: 4,
    doors: 2,
    transmission: 'Automatique',
    fuel: 'Essence',
    engine: '450 CH V8',
    pricePerDay: 290,
    image: 'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/c5a3898619556428ff77553a83037eb7.jpeg',
    gallery: [
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/c5a3898619556428ff77553a83037eb7.jpeg',
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/05881affcaf4e4048ba16ac43e1a1446.jpeg',
      'https://public.readdy.ai/ai/img_res/b73cadcd93c4ff4d6b0615fe688507da.jpg'
    ],
    description: 'La Mustang GT rouge incarne la passion et la performance. Vivez l\'expérience américaine ultime sur les routes mythiques de Saint-Tropez à Monaco.',
    features: [
      'Toit décapotable électrique',
      'GPS intégré',
      'Sièges cuir chauffants',
      'Système audio premium',
      'Bluetooth',
      'Caméra de recul'
    ]
  },
  {
    id: 3,
    name: 'JEEP WRANGLER',
    model: 'Jeep Wrangler Rubicon',
    type: 'SUV 4x4',
    seats: 5,
    doors: 4,
    transmission: 'Automatique',
    fuel: 'Diesel',
    engine: '200 CH',
    pricePerDay: 220,
    image: 'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/0a1bdd7266ee6f6deeab14a0b30963f7.jpeg',
    gallery: [
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/0a1bdd7266ee6f6deeab14a0b30963f7.jpeg',
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/cb8cda2f1f20ec8bd4b797112e8f8b70.jpeg',
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/c056fe66d0632f5115e51c371d7a26d1.jpeg'
    ],
    description: 'Aventure et liberté sur la Côte d\'Azur. Le Jeep Wrangler Rubicon vous permet d\'explorer aussi bien les plages que l\'arrière-pays provençal en toute confiance.',
    features: [
      'Toit amovible',
      'GPS tout-terrain',
      'Climatisation',
      'Mode 4x4',
      'Bluetooth',
      'Barres de toit'
    ]
  },
  {
    id: 4,
    name: 'JAGUAR F-TYPE',
    model: 'Jaguar F-Type R Convertible',
    type: 'Cabriolet Luxe',
    seats: 2,
    doors: 2,
    transmission: 'Automatique',
    fuel: 'Essence',
    engine: '575 CH V8',
    pricePerDay: 490,
    image: 'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/c1e0811f6afd8d171a5553a06c166def.jpeg',
    gallery: [
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/c1e0811f6afd8d171a5553a06c166def.jpeg',
      'https://readdy.ai/api/search-image?query=Interior%20cockpit%20view%20of%20Jaguar%20F-Type%20R%20convertible%20showing%20premium%20leather%20sport%20seats%20elegant%20dashboard%20with%20touchscreen%20and%20aluminum%20trim%20details%20professional%20automotive%20interior%20photography%20warm%20ambient%20light&width=800&height=533&seq=car4jaguar-int1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Dynamic%20rear%20view%20of%20British%20racing%20green%20Jaguar%20F-Type%20R%20convertible%20showing%20quad%20exhaust%20pipes%20and%20sleek%20rear%20design%20parked%20on%20Mediterranean%20coastal%20promenade%20with%20sea%20view%20professional%20automotive%20photography&width=800&height=533&seq=car4jaguar-rear1&orientation=landscape'
    ],
    description: 'Élégance britannique et performances exceptionnelles. La Jaguar F-Type R Cabriolet allie raffinement et puissance pour une expérience de conduite unique sur la Riviera.',
    features: [
      'Toit décapotable',
      'GPS Jaguar',
      'Sièges sport cuir',
      'Son Meridian',
      'Mode Dynamic',
      'Caméra 360°'
    ]
  },
  {
    id: 5,
    name: 'RANGE ROVER',
    model: 'Range Rover Vogue',
    type: 'SUV Luxe',
    seats: 5,
    doors: 4,
    transmission: 'Automatique',
    fuel: 'Diesel',
    engine: '300 CH',
    pricePerDay: 390,
    image: 'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/f18018293cd0a5b4de752884f63b4c95.jpeg',
    gallery: [
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/f18018293cd0a5b4de752884f63b4c95.jpeg',
      'https://readdy.ai/api/search-image?query=Luxurious%20interior%20of%20white%20Range%20Rover%20Vogue%20showing%20premium%20cream%20leather%20seats%20panoramic%20sunroof%20and%20elegant%20wood%20trim%20dashboard%20with%20dual%20touchscreens%20professional%20automotive%20interior%20photography%20bright%20ambient%20light&width=800&height=533&seq=car5rr-int1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Side%20profile%20view%20of%20white%20Range%20Rover%20Vogue%20SUV%20driving%20along%20palm%20tree%20lined%20boulevard%20on%20French%20Riviera%20Mediterranean%20architecture%20in%20background%20premium%20luxury%20vehicle%20professional%20automotive%20photography%20sunny%20day&width=800&height=533&seq=car5rr-side1&orientation=landscape'
    ],
    description: 'Le summum du luxe et du confort. Le Range Rover Vogue offre une expérience de conduite prestigieuse, parfait pour explorer la Côte d\'Azur avec élégance et raffinement.',
    features: [
      'Intérieur cuir premium',
      'GPS premium',
      'Climatisation 4 zones',
      'Sièges massants',
      'Toit panoramique',
      'Système audio Meridian'
    ]
  },
  {
    id: 6,
    name: 'PORSCHE 911',
    model: 'Porsche 911 Carrera S Cabriolet',
    type: 'Cabriolet Sport',
    seats: 4,
    doors: 2,
    transmission: 'Automatique PDK',
    fuel: 'Essence',
    engine: '450 CH',
    pricePerDay: 590,
    image: 'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/3ffb668f1935abfd14ce9c10306aec3a.jpeg',
    gallery: [
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/3ffb668f1935abfd14ce9c10306aec3a.jpeg',
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/3d34bea7803775700d7b5ae9bac3da24.jpeg',
      'https://readdy.ai/api/search-image?query=Rear%20three%20quarter%20view%20of%20white%20Porsche%20911%20Carrera%20S%20Cabriolet%20showing%20iconic%20rear%20engine%20design%20and%20light%20bar%20parked%20at%20scenic%20Mediterranean%20overlook%20with%20sea%20view%20professional%20automotive%20photography%20golden%20hour&width=800&height=533&seq=car6porsche-rear1&orientation=landscape'
    ],
    description: 'L\'icône sportive par excellence. La Porsche 911 Cabriolet vous offre des sensations uniques cheveux au vent entre Saint-Tropez et Monaco sur les routes mythiques de la Côte d\'Azur.',
    features: [
      'Toit décapotable',
      'GPS Porsche',
      'Sièges sport cuir',
      'Son Bose',
      'Mode Sport+',
      'Caméra 360°'
    ]
  }
];
